/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `created` - created
 * * `starting` - starting
 * * `initialized` - initialized
 * * `queued` - queued
 * * `ended` - ended
 * * `postprocessing` - postprocessing
 * * `finished` - finished
 * * `crashed` - crashed
 * @export
 */
export const SimulationStatusNameEnum = {
  CREATED: "created",
  STARTING: "starting",
  INITIALIZED: "initialized",
  QUEUED: "queued",
  ENDED: "ended",
  POSTPROCESSING: "postprocessing",
  FINISHED: "finished",
  CRASHED: "crashed",
} as const;
export type SimulationStatusNameEnum =
  (typeof SimulationStatusNameEnum)[keyof typeof SimulationStatusNameEnum];

export function instanceOfSimulationStatusNameEnum(value: any): boolean {
  for (const key in SimulationStatusNameEnum) {
    if (Object.prototype.hasOwnProperty.call(SimulationStatusNameEnum, key)) {
      if (SimulationStatusNameEnum[key as keyof typeof SimulationStatusNameEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SimulationStatusNameEnumFromJSON(json: any): SimulationStatusNameEnum {
  return SimulationStatusNameEnumFromJSONTyped(json, false);
}

export function SimulationStatusNameEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationStatusNameEnum {
  return json as SimulationStatusNameEnum;
}

export function SimulationStatusNameEnumToJSON(value?: SimulationStatusNameEnum | null): any {
  return value as any;
}

export function SimulationStatusNameEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): SimulationStatusNameEnum {
  return value as SimulationStatusNameEnum;
}
